import {
  SET_QR_LIST,
  SET_CUTTING_LINES,
  SET_ELEMS_IN_ROW,
  SET_SCAN_FOR_PAGE,
  CLEAR_SELECTED_QRS,
} from './actions';

const initialState = {
  scanForPageId: 0,
  scanForPagePath: 'overview',
  elemsInRow: 1,
  cuttingLinesShown: true,
  selectedQRS: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case SET_QR_LIST: {
      const { selectedQRS } = action;
      return {
        ...state,
        selectedQRS,
      };
    }
    case SET_CUTTING_LINES: {
      const { cuttingLinesShown } = action;
      return {
        ...state,
        cuttingLinesShown,
      };
    }
    case SET_SCAN_FOR_PAGE: {
      const { scanForPageId, scanForPagePath } = action;
      return {
        ...state,
        scanForPageId,
        scanForPagePath,
      };
    }
    case SET_ELEMS_IN_ROW: {
      const { elemsInRow } = action;
      return {
        ...state,
        elemsInRow,
      };
    }
    case CLEAR_SELECTED_QRS: {
      return { ...state, selectedQRS: [] };
    }
    default: {
      return state;
    }
  }
}
